(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('permissionsItem', permissionsItem);

    function permissionsItem() {
        return {
            restrict: 'E',
            controller: permissionsItemCtrl,
            controllerAs: 'vm',
            bindToController: true,
            scope: {
                item: '=',
            },
            templateUrl: 'common/app/components/permissions/item'
        };
    }

    function permissionsItemCtrl($scope) {
        var vm = this;
        this.$onInit = function() {
            vm.service = $scope.$parent.vm.service;
            vm.toggle = function() {
                if (vm.service.getModelReadOnly(vm.item)) {
                    return;
                }
                vm.service.toggle(vm.item);
            };
            vm.getClass = function() {
                return vm.service.getModel(vm.item) ? 'fa-check-square-o' : 'fa-square-o';
            };
            vm.getReadOnlyClass = function() {
                if (vm.service.getModelReadOnly(vm.item)) {
                    return 'readonly';
                }
                return '';
            };
        }
    }
})();